<template>
  <div class="record-log" v-show="status">
    <div class="content" :class="{ fullscreen: fullscreen }">
      <div class="title">
        笔录日志 <button class="full-btn click" @click="_fullscreen">{{ fullscreen ? '还原' : '全屏' }}</button>
        <img @click="$emit('handle', { type: 4, event: -1 })" class="click" src="../assets/icon_close_black.png" alt="">
      </div>
      <!-- 列表 -->
      <template v-if="!detailMode">
        <a-empty description="暂无记录" v-if="!loading && list.length === 0" />
        <div class="list" v-else>
          <div class="item click" v-for="(item, index) in list" :key="index" @click="_showDetail(item)">
            <div class="time">{{ $util.formatDate(item.ctime) }}</div>
            <div class="preview ellipsis">{{ _strip(item.content) }}</div>
          </div>
        </div>
        <div class="page" v-if="total > 0">
          <config-provider :locale="zhCN">
            <a-pagination
              show-quick-jumper
              show-size-changer
              :page-size-options="['10', '20', '50']"
              :current="param.page"
              :page-size="param.limit"
              :total="total"
              @change="_pageChange"
              @showSizeChange="_sizeChange"
            />
          </config-provider>
        </div>
      </template>
      <!-- 详情 -->
      <div class="detail" v-else>
        <div class="detail-head">
          <button class="back click" @click="_back">返回</button>
          <span class="time">{{ $util.formatDate(current.ctime) }}</span>
        </div>
        <div class="detail-content" v-html="current.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { recordLogList } from '@/service/getData'
import { ConfigProvider } from 'ant-design-vue'
import zhCN from 'ant-design-vue/lib/locale/zh_CN'
export default {
  components: {
    ConfigProvider
  },
  props: {
    id: {
      default: -1
    },
    status: {
      default: false
    }
  },
  data () {
    return {
      zhCN,
      list: [],
      total: 0,
      loading: false,
      detailMode: false,
      fullscreen: false,
      current: {},
      param: {
        page: 1,
        limit: 10,
        offset: 0
      }
    }
  },
  methods: {
    /**
     * 获取笔录日志列表
     */
    async _getList () {
      this.loading = true
      var res = await recordLogList({ ...this.param, meetingId: this.id })
      this.loading = false
      if (res.code === 1) {
        this.list = res.rows
        this.total = res.total
      }
    },

    /**
     * 页码切换
     */
    _pageChange (page) {
      this.param.page = page
      this.param.offset = this.param.limit * (page - 1)
      this._getList()
    },

    /**
     * 每页条数切换
     */
    _sizeChange (current, size) {
      this.param.limit = size
      this.param.page = 1
      this.param.offset = 0
      this._getList()
    },

    /**
     * 查看详情
     */
    _showDetail (item) {
      this.current = item
      this.detailMode = true
    },

    /**
     * 返回列表
     */
    _back () {
      this.detailMode = false
      this.current = {}
    },

    /**
     * 弹窗内全屏切换
     */
    _fullscreen () {
      this.fullscreen = !this.fullscreen
    },

    /**
     * 去掉 HTML 标签，生成纯文本预览
     */
    _strip (html) {
      var div = document.createElement('div')
      div.innerHTML = html || ''
      return div.innerText || div.textContent || ''
    }
  },
  watch: {
    status (newStatus, oldStatus) {
      if (newStatus) {
        this.detailMode = false
        this.fullscreen = false
        this.current = {}
        this.param.page = 1
        this.param.offset = 0
        this._getList()
      }
    }
  }
}
</script>

<style lang="scss">
@import "../style/mixin";
.record-log {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.3);
  .content {
    @include ct;
    background-color: #F0F0F0;
    border-radius: 0.083rem;
    overflow: hidden;
    right: 2.53rem;
    width: 700px;
    &.fullscreen {
      right: 0;
      left: 0;
      top: 0;
      bottom: 0;
      transform: none;
      width: auto;
      height: auto;
      border-radius: 0;
      display: flex;
      flex-direction: column;
      .list {
        flex: 1;
        height: auto;
        min-height: 0;
      }
      .detail {
        flex: 1;
        height: auto;
        min-height: 0;
      }
      .page {
        flex-shrink: 0;
      }
    }
    .title {
      height: 0.442rem;
      line-height: 0.442rem;
      font-size: 0.15rem;
      font-family: PingFang SC;
      font-weight: bold;
      text-align: center;
      position: relative;
      .full-btn {
        margin-left: 0.1rem;
        font-size: 0.133rem;
        color: #3D97E6;
        background: transparent;
        border: none;
      }
      img {
        position: absolute;
        z-index: 2;
        right: 0.133rem;
        top: 0.125rem;
        @include wh(0.2rem, 0.2rem)
      }
    }
    .list {
      height: 5rem;
      overflow: auto;
      margin: 0 0.167rem;
      .item {
        background-color: #fff;
        margin-bottom: 0.1rem;
        padding: 0.15rem;
        border-radius: 0.083rem;
        .time {
          font-size: 0.133rem;
          color: #333333;
        }
        .preview {
          font-size: 0.117rem;
          color: #666666;
          margin-top: 0.05rem;
        }
      }
    }
    .page {
      text-align: center;
      padding: 0.15rem 0 0.2rem;
    }
    .detail {
      height: 5rem;
      margin: 0 0.167rem;
      background-color: #fff;
      border-radius: 0.083rem;
      padding: 0.15rem;
      display: flex;
      flex-direction: column;
      .detail-head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 0.1rem;
        border-bottom: 1px solid #eee;
        .back {
          background-color: #267CD0;
          color: #fff;
          padding: 0.05rem 0.15rem;
          border-radius: 0.25rem;
          font-size: 0.117rem;
        }
        .time {
          font-size: 0.117rem;
          color: #666666;
        }
      }
      .detail-content {
        flex: 1;
        overflow: auto;
        margin-top: 0.1rem;
        font-size: 0.133rem;
        color: #333333;
        word-break: break-all;
      }
    }
  }
}
</style>
